export { default } from './sanitizeTemplateString'
export * from './sanitizeTemplateString'
